function i(a = "") {
  return a === "" ? {} : a.split(";").reduce(
    (e, n) => {
      let [r, u] = n.split(/^([^:]+):/).filter((t, p) => p > 0).map((t) => t.trim().toLowerCase());
      return u === void 0 || (r = r.replace(/^-ms-/, "ms-").replace(/-(.)/g, (t, p) => p.toUpperCase()), e[r] = u), e;
    },
    {}
  );
}
export {
  i as default
};
//# sourceMappingURL=index.es76.js.map
